import React from "react";
import PropTypes from "prop-types";

import LoadingSpinner from "../../../shared_components/loading_spinner";

export default (mainComponents, FOCUS_VIEW_TYPES, showComponentWhenLoading) => {
  class MainView extends React.Component {
    render () {
      const focusViewType = this.props.focusView.type;
      const MainComponent = mainComponents[focusViewType];
      const showWhenLoading = showComponentWhenLoading[focusViewType];

      let mainComponent = <div></div>;
      if (showWhenLoading || !this.props.isLoading) {
        mainComponent = <MainComponent />;
      }
      return (
        <div className="main-view">
          {mainComponent}
          <LoadingSpinner show={this.props.isLoading} />
        </div>
      );
    }
  }

  MainView.propTypes = {
    focusView: PropTypes.shape({
      type: PropTypes.oneOf(FOCUS_VIEW_TYPES).isRequired
    }).isRequired,
    isLoading: PropTypes.bool.isRequired
  };

  return MainView;
};
